import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img[appHideBrokenImg]'
})
export class HideBrokenImgDirective {

  constructor(private el: ElementRef<HTMLImageElement>) { }

  @HostListener('error')
  onError(): void {
    this.el.nativeElement.style.display = 'none';
  }

  // src can be rebound to a valid URL after a failure, so un-hide on a successful load.
  @HostListener('load')
  onLoad(): void {
    this.el.nativeElement.style.display = '';
  }
}
